/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenW
 */
export interface TokenW {
    /**
     * NO_DESCRIPTION
     * @type {string}
     * @memberof TokenW
     */
    session: string;
    /**
     * NO_DESCRIPTION
     * @type {string}
     * @memberof TokenW
     */
    role: string;
    /**
     * comments
     * @type {string}
     * @memberof TokenW
     */
    comments: string;
    /**
     * valid after
     * @type {Date}
     * @memberof TokenW
     */
    validAfter: Date;
    /**
     * valid before
     * @type {Date}
     * @memberof TokenW
     */
    validBefore?: Date | null;
}

/**
 * Check if a given object implements the TokenW interface.
 */
export function instanceOfTokenW(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "session" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "comments" in value;
    isInstance = isInstance && "validAfter" in value;

    return isInstance;
}

export function TokenWFromJSON(json: any): TokenW {
    return TokenWFromJSONTyped(json, false);
}

export function TokenWFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenW {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'session': json['session'],
        'role': json['role'],
        'comments': json['comments'],
        'validAfter': (new Date(json['valid_after'])),
        'validBefore': !exists(json, 'valid_before') ? undefined : (json['valid_before'] === null ? null : new Date(json['valid_before'])),
    };
}

export function TokenWToJSON(value?: TokenW | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'session': value.session,
        'role': value.role,
        'comments': value.comments,
        'valid_after': (value.validAfter.toISOString()),
        'valid_before': value.validBefore === undefined ? undefined : (value.validBefore === null ? null : value.validBefore.toISOString()),
    };
}

